import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type StoriesStore = {
  watched: Set<string>;
  markAsWatched: (id: string) => void;
  isWatched: (id: string) => boolean;
  resetWatched: () => void;
};

export const useStoriesStore = create<StoriesStore>()(
  persist(
    (set, get) => ({
      watched: new Set(),

      markAsWatched: (id: string) =>
        set((state) => {
          const updated = new Set(state.watched)
          updated.add(id)
          return { watched: updated }
        }),

      isWatched: (id: string) => get().watched.has(id),

      resetWatched: () => set({ watched: new Set() }),
    }),
    {
      name: 'stories-watched',
      partialize: (state) => ({
        watched: Array.from(state.watched),
      }),
      merge: (persistedState: unknown, currentState) => ({
        ...currentState,
        watched: new Set((persistedState as { watched?: string[] })?.watched || []),
      }),
    },
  ),
)
